import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';

export const label = css(typography.effra16, {
  display: 'block',
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  marginBottom: 16,
});

export const controls = css({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
});

export const numberButton = css({
  display: 'block',
  width: 48,
  height: 48,
  border: `1px solid ${colorsPalette.grey20}`,
  transition: 'border-color 0.3s, color 0.3s',
  backgroundColor: colorsPalette.white,
  borderRadius: '50%',
  fontWeight: fontWeights.light,
  fontSize: 25,
  cursor: 'pointer',
  lineHeight: 1.5,
  padding: 0,

  ':hover, :focus': {
    borderColor: colorsPalette.grey40,
    outline: 0,
  },

  ':disabled': {
    borderColor: colorsPalette.grey10,
  },
});

export const input = css(typography.effra22, {
  WebkitAppearance: 'none',
  height: 56,
  backgroundColor: colorsPalette.white,
  border: `1px solid ${colorsPalette.grey20}`,
  borderRadius: 2,
  display: 'block',
  flex: 1,
  margin: '0 16px',
  textAlign: 'center',
  minWidth: 0,
  width: '100%',

  ':hover, :focus': {
    borderColor: colorsPalette.grey40,
    outline: 0,
  },

  '::-webkit-input-placeholder': {
    color: colorsPalette.black,
  },

  ':-ms-input-placeholder': {
    color: colorsPalette.black,
  },

  '::placeholder': {
    color: colorsPalette.black,
  },
});
